
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/sdk/in-app-payment/android",
      function () {
        return require("private-next-pages/docs/sdk/in-app-payment/android.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/sdk/in-app-payment/android"])
      });
    }
  